import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/search.svg'
import _imports_1 from '@/assets/img/cross.png'


const _withScopeId = n => (_pushScopeId("data-v-f1c3297a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper__input" }
const _hoisted_2 = ["value", "onKeyup"]
const _hoisted_3 = { class: "wrapper__input__reset" }

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

let message = computed(() => store.getters.getName);

function updateMessage(e: Event) {
  store.commit('setFilters', {
    ...store.state.charactersModule.filters,
    name: (e.target as HTMLInputElement).value,
  });
}

const isTyping = computed(() => store.getters.isTyping);

function setSearchValue() {
  let newObj = { ...store.state.charactersModule.filters };
  delete newObj.page;
  store.commit('setCurrentPage', 1);
  store.commit('setFilters', {
    ...newObj,
  });
  store.dispatch('fetchCharacters');
}

function clearFilters() {
  store.commit('setFilters', {});
  store.dispatch('fetchCharacters');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", { class: "wrapper__input__search" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "search icon",
        width: "20",
        onClick: setSearchValue
      })
    ]),
    _createElementVNode("input", {
      type: "text",
      placeholder: "Search for a characters...",
      value: _unref(message),
      onInput: updateMessage,
      onKeyup: _withKeys(setSearchValue, ["enter"])
    }, null, 40, _hoisted_2),
    _createElementVNode("button", _hoisted_3, [
      (_unref(isTyping))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_1,
            width: "40",
            height: "40",
            alt: "cross icon",
            onClick: clearFilters
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})